import { css } from '@emotion/react';
import { useNavPage } from '@/hooks/useNavPage';

const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 56px 0;
  flex: 1;

  @media (max-width: 1169px) {
    padding: 48px 16px;
  }
`;

const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1140px;
  max-width: 100%;
`;

const tabs = css`
  display: flex;
  gap: 24px;
`;

const tab = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 28.6px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
`;

const tabActive = css`
  ${tab};
  color: #241a17;
`;

const tabInactive = css`
  ${tab};
  color: rgba(61, 46, 41, 0.52);
`;

const actions = css`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const textButton = css`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 8px;
  border-radius: 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #251b18;
  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const newButton = css`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding: 0 17px;
  border: none;
  border-radius: 6px;
  background: #251b18;
  color: #f8f7f7;
  cursor: pointer;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  &:hover {
    background: #2a2a28;
  }
  svg {
    color: #a39a97;
  }
`;

const card = css`
  display: flex;
  flex-direction: column;
  width: 1140px;
  max-width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 16px 32px 8px;
  box-shadow:
    0px 1px 1px -0.1px rgba(0, 0, 0, 0.05),
    0px 1.98px 3.06px -0.36px rgba(0, 0, 0, 0.05);
`;

const tableRow = css`
  display: grid;
  grid-template-columns: 100px 1fr 120px 80px 80px 1fr 60px;
  align-items: center;
  height: 64px;
  border-bottom: 1px solid rgba(60, 50, 47, 0.12);
  gap: 16px;
`;

const headerRow = css`
  display: grid;
  grid-template-columns: 100px 1fr 120px 80px 80px 1fr 60px;
  align-items: center;
  height: 36px;
  gap: 16px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #241a17;
`;

const cellText = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #241a17;
`;

const mutedText = css`
  ${cellText};
  color: rgba(57, 48, 45, 0.52);
`;

const badgeBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 112px;
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
`;

const badgeActive = css`
  ${badgeBase};
  background: #dcf2cf;
  color: #1f4002;
`;

const badgeInactive = css`
  ${badgeBase};
  background: transparent;
  color: rgba(61, 46, 41, 0.52);
  border: 1px solid rgba(55, 49, 47, 0.2);
`;

const iconButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(61, 46, 41, 0.52);
  &:hover {
    background: rgba(58, 58, 44, 0.06);
  }
`;

const discounts = [
  {
    status: 'active',
    name: '50% OFF November',
    code: 'NOV50',
    amount: '50%',
    used: 34,
    applicable: 'All products',
  },
  {
    status: 'active',
    name: '$15 first time discount',
    code: 'HOLA15',
    amount: '$15',
    used: 21,
    applicable: 'Food Styling Workshop + 2 more',
  },
  {
    status: 'inactive',
    name: '20% OFF Christmas',
    code: 'OFF20',
    amount: '$15',
    used: 156,
    applicable: 'Photography Basics for Beginners',
  },
  {
    status: 'active',
    name: '10% discount',
    code: 'SAVE10',
    amount: '$15',
    used: 156,
    applicable: 'Culinary Techniques Masterclass cou...',
  },
  {
    status: 'active',
    name: 'Free shipping on orders over $50',
    code: 'FALL25',
    amount: '$15',
    used: 156,
    applicable: 'All products',
  },
  {
    status: 'inactive',
    name: '30% OFF App Launch Celebration',
    code: 'WINTER30',
    amount: '20%',
    used: 156,
    applicable: 'All products',
  },
];

export default function DiscountsView() {
  const [, setNavPage] = useNavPage();

  return (
    <div css={wrapper}>
      <div css={header}>
        <div css={tabs}>
          <button css={tabInactive} type="button" onClick={() => setNavPage('products')}>
            My products
          </button>
          <button css={tabActive} type="button">
            Discounts
          </button>
        </div>
        <div css={actions}>
          <button css={textButton} type="button">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <circle cx="7.5" cy="7.5" r="6" stroke="currentColor" strokeWidth="1.5" />
              <path
                d="M12 12L16.5 16.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            Search
          </button>
          <button css={textButton} type="button">
            Status
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none">
              <path
                d="M1 7L5 11L9 7"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button css={newButton} type="button">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path
                d="M7 1V13M1 7H13"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
            New discount
          </button>
        </div>
      </div>

      <div css={card}>
        <div css={headerRow}>
          <div>Status</div>
          <div>Name</div>
          <div>Code</div>
          <div>Amount</div>
          <div>Used</div>
          <div>Applicable to</div>
          <div />
        </div>
        {discounts.map(d => {
          const isInactive = d.status === 'inactive';
          return (
            <div key={d.code} css={tableRow}>
              <div>
                <span css={isInactive ? badgeInactive : badgeActive}>
                  {isInactive ? 'Inactive' : 'Active'}
                </span>
              </div>
              <div css={isInactive ? mutedText : cellText}>{d.name}</div>
              <div css={isInactive ? mutedText : cellText}>{d.code}</div>
              <div css={isInactive ? mutedText : cellText}>{d.amount}</div>
              <div css={isInactive ? mutedText : cellText}>{d.used}</div>
              <div css={isInactive ? mutedText : cellText}>{d.applicable}</div>
              <div>
                <button css={iconButton} type="button" aria-label="More">
                  <svg width="15" height="18" viewBox="0 0 15 18" fill="none">
                    <circle cx="2" cy="9" r="1.5" fill="currentColor" />
                    <circle cx="7.5" cy="9" r="1.5" fill="currentColor" />
                    <circle cx="13" cy="9" r="1.5" fill="currentColor" />
                  </svg>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
